import { useCallback, useMemo } from 'react';
import { fetchData } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';
import {
  ERRORS_TEMPLATES,
  isErrorTemplate,
} from 'utils/errorMessageValidation';

// TODO: Refactor to react query
const useDigitalSignature = () => {
  const { showError } = useError();
  const { error } = useSmartlook();

  const postVereficationCodeToClient = useCallback(async () => {
    try {
      const data = await fetchData(
        '/client/application/send-verification-code',
        {
          method: 'post',
        },
      );

      return data;
    } catch (e) {
      error('[useDigitalSignature][postVereficationCodeToClient]', e);
      showError();
      throw e;
    }
  }, [showError]);

  const postDigitalSignature = useCallback(
    async (code: string) => {
      try {
        const data = await fetchData('/client/application/verify-code', {
          method: 'post',
          body: JSON.stringify({ code }),
        });

        return data;
      } catch (e) {
        error('[useDigitalSignature][postDigitalSignature]', e);
        if (!isErrorTemplate(e, ERRORS_TEMPLATES.INCORRECT_CODE)) {
          showError();
        }
        throw e;
      }
    },
    [showError],
  );

  return useMemo(() => {
    return {
      postVereficationCodeToClient,
      postDigitalSignature,
    };
  }, [postVereficationCodeToClient, postDigitalSignature]);
};

export default useDigitalSignature;
